module.exports = __webpack_public_path__ + "img/f2.39481904.png";